export default __webpack_public_path__ + "static/media/taobao.10bb2ae0.svg";